<template>
  <section
    v-if="variants.v1 === variant"
    class="n-section-primary tw-bg-cover tw-bg-center"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <div class="container">
      <div class="row align-items-start">
        <div class="col-xl-7 col-lg-7 col-md-7 col-sm-9">
          <div class="section-title">
            <div class="heading-animation">
              <h2>
                <svg
                  v-if="vars.isVisibleBool"
                  width="1em"
                  height="1em"
                  viewBox="0 0 33 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                  style="display: inline"
                >
                  <rect width="40.9678" height="40.9678" fill="#E4002B" />
                  <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" /></svg
                ><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-5 wow fadeInUp" data-wow-delay=".6s">
          <div class="p-animation">
            <p
              v-for="({ description }, index) in descriptions"
              :key="`takeaction-description-${index}`"
              class="tw-max-w-2xl"
              :style="`color: var(--c-${vars.textColor});`"
            >
              {{ description }}
            </p>
          </div>
          <div class="tw-mt-6 tw-flex tw-flex-wrap tw-justify-start tw-gap-3">
            <nuxt-link
              v-for="(button, index) in buttons"
              :external="true"
              :key="`button-${index}`"
              :class="[
                buttons.length >= 2 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto',
                `n-${button.button_type}`,
                'tw-uppercase',
              ]"
              :to="button.button_link"
            >
              {{ button.button_label }}
              <span class="btn-arrow"
                ><svg width="9" height="15" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.92455 7.41479L2.62464 10.7147L1.7998 9.88987L4.6873 7.00237L1.7998 4.11487L2.62464 3.29004L5.92455 6.58996C6.03391 6.69935 6.09535 6.84769 6.09535 7.00237C6.09535 7.15705 6.03391 7.3054 5.92455 7.41479Z"
                    fill="white"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="n-section-primary tw-bg-cover tw-bg-center tw-text-center"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <div class="container">
      <div class="col tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4">
        <div class="col-xl-7 col-lg-7 col-md-7 col-sm-9">
          <div class="section-title">
            <div class="heading-animation">
              <h2>
                <svg
                  v-if="vars.isVisibleBool"
                  width="1em"
                  height="1em"
                  viewBox="0 0 33 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                  style="display: inline"
                >
                  <rect width="40.9678" height="40.9678" fill="#E4002B" />
                  <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" /></svg
                ><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-5 wow fadeInUp" data-wow-delay=".6s">
          <div class="p-animation">
            <p
              v-for="({ description }, index) in descriptions"
              :key="`takeaction-description-${index}`"
              class="tw-max-w-2xl"
              :style="`color: var(--c-${vars.textColor});`"
            >
              {{ description }}
            </p>
          </div>
          <div class="tw-mt-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-3">
            <nuxt-link
              v-for="(button, index) in buttons"
              :external="true"
              :key="`button-${index}`"
              :class="[
                buttons.length >= 2 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto',
                `n-${button.button_type}`,
                'tw-uppercase',
              ]"
              :to="button.button_link"
            >
              {{ button.button_label }}
              <span class="btn-arrow"
                ><svg width="9" height="15" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.92455 7.41479L2.62464 10.7147L1.7998 9.88987L4.6873 7.00237L1.7998 4.11487L2.62464 3.29004L5.92455 6.58996C6.03391 6.69935 6.09535 6.84769 6.09535 7.00237C6.09535 7.15705 6.03391 7.3054 5.92455 7.41479Z"
                    fill="white"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TakeAction',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
